import { isFunction } from 'lodash-es';
import React, { Component, ReactNode } from 'react';

import { responsiveAliases } from './Breakpoints';
import { ResponsiveContext, ResponsiveContextProps } from './ResponsiveContext';

interface ResponsiveQueryProps {
  query: responsiveAliases | responsiveAliases[];
  children: () => ReactNode;
}

export class ResponsiveQuery extends Component<ResponsiveQueryProps> {
  renderChildren(queryMatches: ResponsiveContextProps) {
    const { query, children } = this.props;
    const match = Array.isArray(query)
      ? query.find((q) => queryMatches[q])
      : queryMatches[query];

    if (match) {
      if (isFunction(children)) {
        return children();
      }
      return children;
    } else {
      return null;
    }
  }

  render() {
    return (
      <ResponsiveContext.Consumer>
        {this.renderChildren.bind(this)}
      </ResponsiveContext.Consumer>
    );
  }
}
